import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import API_ROUTES from "../../../api-routes";
import apiService from "../../../services/service";

const initialState = {};

export const tasksUpdation = createAsyncThunk(
  "tasksSlice/taskUpdation",
  async (data) => {
    const id = data?.id;
    return await apiService(API_ROUTES.UPDATE_TASKS, "PUT", {
      replace: { id },
      body: JSON.stringify(data),
    });
  },
);

export const taskCommentsAddition = createAsyncThunk(
  "tasksSlice/taskCommentsAddition",
  async (data, { rejectWithValue }) => {
    try {
      const taskId = data?.id;
      return await apiService(API_ROUTES.ADD_COMMENTS, "POST", {
        replace: { taskId },
        body: JSON.stringify(data),
      });
    } catch (err) {
      return rejectWithValue(
        `An unexpected error occurred while adding comment: ${err?.message}`,
      );
    }
  },
);

const tasksSlice = createSlice({
  name: "tasksSlice",
  initialState,
  reducers: {
    setTasksData: (state, { payload }) => {
      state[payload.key] = payload.value;
    },
  },
  extraReducers: () => {},
});

export const { setTasksData } = tasksSlice.actions;
export default tasksSlice.reducer;
